module.exports = __webpack_public_path__ + "img/c7766e8.jpg";